import { useCallback } from 'react';

interface UseDrawerCloseGuardOptions {
  hasUnsavedChanges: boolean;
  onClose: () => void;
  message?: string;
}

export function useDrawerCloseGuard({
  hasUnsavedChanges,
  onClose,
  message = '작성 중인 수정요청이 사라져요. 닫을까요?',
}: UseDrawerCloseGuardOptions) {
  return useCallback(() => {
    if (!hasUnsavedChanges || window.confirm(message)) {
      onClose();
    }
  }, [hasUnsavedChanges, message, onClose]);
}
